import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { Route, CreateRouteRequest } from '../types';

export const routeService = {
  getAll: async (): Promise<Route[]> => {
    const response = await apiClient.get<Route[]>(API_ENDPOINTS.ROUTES.BASE);
    return response.data;
  },

  getActive: async (): Promise<Route[]> => {
    const response = await apiClient.get<Route[]>(API_ENDPOINTS.ROUTES.ACTIVE);
    return response.data;
  },

  getById: async (id: number): Promise<Route> => {
    const response = await apiClient.get<Route>(API_ENDPOINTS.ROUTES.BY_ID(id));
    return response.data;
  },

  create: async (data: CreateRouteRequest): Promise<Route> => {
    const response = await apiClient.post<Route>(API_ENDPOINTS.ROUTES.BASE, data);
    return response.data;
  },

  update: async (id: number, data: Partial<CreateRouteRequest>): Promise<Route> => {
    const response = await apiClient.put<Route>(API_ENDPOINTS.ROUTES.BY_ID(id), data);
    return response.data;
  },

  deactivate: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.ROUTES.BY_ID(id));
  },
};
